<template>
  <div class="w-full mx-auto p-6 bg-white shadow rounded">
    <label class="block font-semibold mb-1">Title *</label>
    <input
      v-model="form.title"
      type="text"
      placeholder="Enter Title"
      class="w-full border border-gray-300 rounded px-3 py-2 mb-4 focus:ring focus:ring-blue-400 focus:border-blue-400"
    />

    <label class="block font-semibold mb-1">Short Description *</label>
    <textarea
      v-model="form.short_desc"
      placeholder="Enter short description"
      class="w-full border border-gray-300 rounded px-3 py-2 mb-4 focus:ring focus:ring-blue-400 focus:border-blue-400"
    ></textarea>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
      <div class="lg:col-span-2">
        <label class="block font-semibold mb-1">Banner *</label>
        <div
          class="w-full border-2 border-dashed rounded relative mb-2 cursor-pointer hover:border-blue-400 transition h-[316px] overflow-hidden"
        >
          <input
            type="file"
            class="hidden"
            ref="fileInput"
            @change="uploadBanner"
            accept=".png, .jpeg, .jpg"
          />
          <div
            @click="$refs.fileInput.click()"
            class="w-full h-full"
          >
            <div v-if="!form.banner" class="flex flex-col items-center justify-center h-full text-gray-500">
              <span class="text-4xl block mb-2">+</span>
              Click to upload or drag and drop
            </div>
            <div v-else class="relative w-full h-full">
              <img
                :src="form.banner"
                class="w-full h-full object-cover object-top"
                alt="Banner Preview"
              />
              <div class="absolute bottom-0 w-full bg-black bg-opacity-50 text-white text-xs py-2 text-center">
                Click to change banner
              </div>
            </div>
          </div>
        </div>
        <p class="text-xs text-gray-500 mb-4">
          .png, .jpeg, .jpg, max size 5MB, recommended size (W1400 x H600)
        </p>

        <div class="flex space-x-4 mb-4 items-center">
          <div>
            <label class="block font-semibold mb-1">Status</label>
            <div class="flex space-x-2">
              <span
                @click="form.status = 'Active'"
                :class="
                  form.status === 'Active'
                    ? 'bg-green-500 text-white'
                    : 'bg-gray-200 text-gray-700'
                "
                class="px-4 py-1 rounded-full text-sm cursor-pointer transition"
              >
                Active
              </span>
              <span
                @click="form.status = 'Inactive'"
                :class="
                  form.status === 'Inactive'
                    ? 'bg-red-500 text-white'
                    : 'bg-gray-200 text-gray-700'
                "
                class="px-4 py-1 rounded-full text-sm cursor-pointer transition"
              >
                Inactive
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="lg:col-span-1 space-y-4">
        <div>
          <label class="block font-semibold mb-1">Meta Keyword *</label>
          <input
            v-model="form.meta_keyword"
            placeholder="Enter meta keyword"
            class="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>
        <div>
          <label class="block font-semibold mb-1">Meta Description *</label>
          <textarea
            v-model="form.meta_desc"
            placeholder="Enter meta description"
            rows="4"
            class="w-full border border-gray-300 rounded px-3 py-2"
          ></textarea>
        </div>
        <div>
          <label class="block font-semibold mb-1">Alt Text *</label>
          <input
            v-model="form.alt_text"
            placeholder="Enter alt text"
            class="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>
      </div>
    </div>

    <label class="block font-semibold mb-1 mt-6">Content *</label>
    <div class="mb-6 border border-gray-300 rounded">
      <TextEditorComponents v-model="form.content" />
    </div>

    <button
      @click="submit"
      class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded shadow transition duration-200"
    >
      Create Article
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import TextEditorComponents from "@/components/Forms/TextEditorComponents"

export default {
  components: {
    TextEditorComponents
  },
  data() {
    return {
      form: {
        title: "",
        short_desc: "",
        banner: null,
        banner_file: null,
        meta_keyword: "",
        meta_desc: "",
        alt_text: "",
        status: "Inactive",
        content: ""
      }
    }
  },

  methods: {
    ...mapActions("article", ["createArticle"]),
    ...mapActions("common", ["showLoading", "hideLoading"]),

    uploadBanner(e) {
      const file = e.target.files[0]
      if (!file) return
      if (file.size > 5 * 1024 * 1024) return alert("File size exceeds 5MB")
      this.form.banner = URL.createObjectURL(file)
      this.form.banner_file = file
    },

    async submit() {
      if (!this.form.title || !this.form.banner_file || !this.form.content) {
        return alert(
          "Please fill all required fields (*) including the banner image."
        )
      }

      this.showLoading()
      try {
        const formData = new FormData()
        formData.append("title", this.form.title)
        formData.append("short_desc", this.form.short_desc)
        formData.append("meta_keyword", this.form.meta_keyword)
        formData.append("meta_desc", this.form.meta_desc)
        formData.append("alt_text", this.form.alt_text)
        formData.append("status", this.form.status)
        formData.append("content", this.form.content)
        formData.append("banner", this.form.banner_file)

        await this.createArticle(formData)
        this.$router.push("/article")
      } catch (err) {
        console.error("Failed to create article:", err)
      } finally {
        this.hideLoading()
      }
    }
  }
}
</script>
